import { query, collection, where, getDocs } from 'firebase/firestore'
import _ from 'lodash'
import * as Sentry from '@sentry/react'

import { db } from 'controllers/db'
import store from 'model/store'
import { DictT, ItemsTemplateT, PartnerT } from 'shared/types/model'
import { receiveTemplates } from 'model/actions'

export const fetchTemplates = async (partner: PartnerT | null) => {
  try {
    const tags = partner ? partner.tags || [] : []
    console.log('fetch templates, tags', tags)
    let q = query(collection(db, 'templates'), where('enabled', '==', true))
    if (!_.isEmpty(tags)) {
      q = query(
        collection(db, 'templates'),
        where('enabled', '==', true),
        where('tags', 'array-contains-any', tags)
      )
    }
    const sn = await getDocs(q)
    const res: DictT<ItemsTemplateT> = {}
    sn.forEach(doc => {
      const p = doc.data() as ItemsTemplateT
      _.set(res, doc.id, p)
    })
    console.log('receive templates ', res)
    store.dispatch(receiveTemplates(res))
  } catch (e) {
    Sentry.captureException(e)
    console.log('fetchTemplates error', e)
  }
}
